import { useMemo } from 'react'

import { useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import EditTaskPricingModal from '@modals/EditTaskPricingModal'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import PageContent from './components/PageContent'

export type PageContextPayload = {
  callbacks: {
    showEditTaskPricingModal: () => void,
  },
}

const defaultState = {
  showEditTaskPricingModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    EditTaskPricingModal: {
      closeModal: () => setState({ showEditTaskPricingModal: false }),
    },
  }

  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showEditTaskPricingModal } = state

  const modalContext = useModals({ setState })
  const { callbacks: { setModalData } } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      showEditTaskPricingModal: (payload: HandleCallbackActionParams) => {
        setModalData('EditTaskPricingModal', payload)
        setState({ showEditTaskPricingModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent />

        <EditTaskPricingModal
          callbacks={callbacks('EditTaskPricingModal', setState)}
          showModal={showEditTaskPricingModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}
export default List
